<template>
  <div
    class="product-thumbnail"
    :class="{'product-thumbnail__empty': !imageUrl(attachment)}">
    <div class="product-thumbnail__image-wrapper">
      <img
        v-if="imageUrl(attachment)"
        v-lazy="imageUrl(attachment)">

      <AppVerifiedMark
        :is-verified="isVerified"
        :child-verified-ws="item.childVerified"
        :verified-page-id="item.verifiedPageId"
        :verified-page-name="item.verifiedPageName"
        class="verified-mark" />
    </div>
  </div>
</template>
<script>
import AppVerifiedMark from '@/components/App/AppVerifiedMark';

import { parseStorageKey } from '@/utils';
import { getS3ImageUrl } from '@/utils/url';

export default {
  name: 'ProductThumbnail',
  components: {
    AppVerifiedMark,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
    attachment: {
      type: [Array, Object],
      default: () => [],
    },
  },
  computed: {
    products: {
      get() {
        return this.items;
      },
      set(val) {
        this.$emit('update:items', val);
      },
    },
    isVerified() {
      return this.item?.isVerified;
    },
  },
  watch: {
    products: {
      handler() {
        this.getImageFromStorage();
      },
      immediate: true,
    },
  },
  methods: {
    imageUrl(attachment) {
      return attachment ? this.smallThumb(attachment[0])?.url : null;
    },
    smallThumb(attachment) {
      const thumbnails = attachment?.thumbnails;
      return thumbnails?.medium || thumbnails?.large;
    },
    async getImageFromStorage() {
      this.products = await Promise.all(this.products.map(async (v)=> {
        try {
          const filtered = v.attachment?.filter(item => item);
          const attachment = filtered?.length && filtered[0];
          const smallThumb = attachment ? this.smallThumb(attachment) : {
          };
          const { url, key: thumbKey } = smallThumb;
          if (!url && thumbKey) {
            const { identityId, key } = parseStorageKey(thumbKey);
            smallThumb.url = await getS3ImageUrl(key, {
              level: 'protected',
              identityId,
            });
          }
        } catch (err) {
          console.log('getImageFromStorage err', err);
        }
        return v;
      }));
    },
  },
};
</script>
<style scoped lang="scss">
  .product-thumbnail {
    padding-block: 12px;

    &__empty {
      background: var(--v-lightGrey-base);
      opacity: 0.2;
    }

    &__image-wrapper {
      position: relative;
      height: fit-content;
      width: fit-content;

      img {
        max-height: 100px;
        max-width: 100%;
        display: block;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
      }
    }
  }
  .verified-mark {
    position: absolute;
    z-index: 4;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
  }
</style>
